import type { TupleToUnion } from 'type-fest'
import { EC20_SOURCE } from './ec2_0'
import { Shopee, Shopify, Shopline, Eccang, SlBrandTiktok } from '@yy/one-icon'

import React from 'react'
/**销售平台 */
export const SALES_PLATFORM = [
  /**SHOPLINE */
  {
    label: 'SHOPLINE',
    value: 'SHOPLINE',
    icon: <Shopline origin fontSize={20} />,
  },

  /**虾皮 */
  {
    label: 'SHOPEE',
    value: 'SHOPEE',
    icon: <Shopee origin fontSize={20} />,
  },
  {
    label: 'SHOPLINE2.0',
    value: EC20_SOURCE,
    icon: <Shopline origin fontSize={20} />,
  },
  {
    label: 'SHOPIFY',
    value: 'SHOPIFY',
    icon: <Shopify origin fontSize={20} />,
  },
  {
    label: 'ECCANG',
    value: 'ECCANG',
    icon: <Eccang origin fontSize={20} />,
  },
  {
    label: 'TIKTOK',
    value: 'TIKTOK',
    icon: <SlBrandTiktok origin fontSize={20} />,
  },
] as const

const SALES_PLATFORM_CODES = SALES_PLATFORM.map((it) => it.value)
// TODO 类型怎么定义 SHOPEE(key) => SHOPEE(value)
/**销售平台 */
export const SALES_PLATFORM_CODE = SALES_PLATFORM.reduce((rs, it) => {
  return Object.assign(rs, { [it.value]: it.value })
}, {} as Record<TupleToUnion<typeof SALES_PLATFORM_CODES>, any>)
